import {toDateOrNull} from "../utils/tools";
import Forms from "./Forms";

const NotesEditor = ({items = [], onChange}) => {
    const add = () => onChange([...(items || []), { text: '', createdAt: new Date() }]);
    const update = (i, patch) => {
        const copy = [...items];
        copy[i] = { ...copy[i], ...patch };
        onChange(copy);
    };
    const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

    return (
        <div className="space-y-2">
            {items.map((n, i) => (
                <div key={i} className="flex gap-3 items-end">
                    <Forms.Textarea label="Poznámka" value={n.text || ''} onChange={v => update(i, { text: v })}/>
                    <div>
                        <div className="opacity-50 text-xs mt-2"> </div>
                        {items.length > 1 && <Forms.Button type="button" variant="danger" label="–" onClick={() => remove(i)}/>}
                    </div>
                </div>
            ))}
            <Forms.Button type="button" variant="secondary" label="+" onClick={add}/>
        </div>
    );
};

export default NotesEditor;